export default "__VITE_ASSET__CYRzyrRt__"